export const dynamicImage = (image) => {
    let imagePath = `${process.env.REACT_APP_PUBLIC_URL}${process.env.REACT_APP_PUBLIC_ASSETS}/images`;

	// if (process.env.REACT_APP_APP_ENVIRONMENT === 'development') {
	// 	imagePath = `${process.env.REACT_APP_PUBLIC_URL}/assets/images`;
  	// }

    return `${imagePath}/${image}`;
};